<template>
  <div class="rtl">
    <v-row class="mt-md-8">
      <v-col cols="12" md="4">
      </v-col>
      <v-col cols="12" md="4" class="pt-5">
        <m-form
            :canSubmit="true"
            :is-editing.sync="isEditing"
            :showListBtn="false"
            :show-navigation-btns="false"
            :show-list="false"
            :show-clear-btn="false"
            :show-submit-and-clear-btn="false"
            :can-delete="false"
            @submit="submit"
        >
          <template #default>
            <v-row class="text--center mb-4">
              <v-img src="/img/icons/moadian.svg" max-width="40" max-height="40"></v-img>
              <span class="font-weight-bold mr-3 black--text mt-3" style="font-size: larger">
                {{ title }}
              </span>
            </v-row>
            <v-row class="mt-5">
              <v-col cols="12" md="12">
                <v-text-field class="rounded-lg" label="* نام کاربری" v-model="item.username" :disabled="!isEditing"/>
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field class="rounded-lg" label="* کلمه عبور" v-model="item.password" :disabled="!isEditing"/>
              </v-col>
            </v-row>
          </template>
        </m-form>

      </v-col>
    </v-row>
  </div>
</template>
<script>
import {MFormMixin} from "@/components/m-form";

export default {
  mixins: [MFormMixin],
  props: {},
  data() {
    return {
      url: "moadian/keysan/config/",
      item: {},
    };
  },
  computed: {
    title() {
      return this.setDocumentTitle('اتصال به مودیان')
    },
  },
  watch: {
    '$route'(to, from) {
      if (to.path === '/panel/moadian/config') {
        this.getData();
      }
    }
  },
  methods: {
    getData() {
      this.getMoadianConfig();
    },
    getMoadianConfig() {
      this.request({
        url: this.endpoint(this.url),
        method: "get",
        success: (data) => {
          this.item = data;
          if (this.item.id) {
            this.isEditing = false;
          }
        },
      });
    },
    submit() {
      this.request({
        url: this.endpoint(this.url),
        method: "post",
        data: this.item,
        success: (data) => {
          this.successNotify();
          this.isEditing = false;
        },
      });
    },
  },
};
</script>
